class TenantService {
  public get Domain() {
    return window.location.host;
  }

  public get Tenant() {
    const domain = window.location.host;
    return domain.slice(0, domain.indexOf('.'));
  }
}

export default new TenantService();
